import { render, staticRenderFns } from "./SnippetPreview.vue?vue&type=template&id=6a3636bf&"
import script from "./SnippetPreview.vue?vue&type=script&lang=js&"
export * from "./SnippetPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports